// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "0815aa26c8cadab4f4dc532131e39c420ea0f4fa/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"21":"2a222798","98":"c3469f9b","215":"28b12c6b","440":"2a9a7941","496":"89e6df15","581":"04bc5b3b","731":"93042797"}[chunkId] + ".chunk.js";
};